import { DateTime } from 'luxon';

import completedConfig from './taskCompletedTime';
import overdueConfig from './taskOverdueTime';
import scheduledConfig from './taskScheduledTime';
import todayConfig from './taskTodayTime';

import type { TaskStatus } from '../types/task.dto';
import type { DateTimeOffset } from '@/app/types/MessageContainer';

export const parseDateTimeOffset = ({ date, time, offset }: DateTimeOffset) => {
	const start = DateTime.fromISO(`${date ?? ''}T${time ?? ''}${offset ?? ''}`);

	if (!start.isValid) {
		return null;
	}

	return start;
};

export const formatStartTime = (value: DateTimeOffset, status: TaskStatus) => {
	const time = parseDateTimeOffset(value);

	if (!time) {
		return '';
	}

	switch (status) {
		case 'completed':
			return completedConfig.formatStart(time);
		case 'scheduled':
			return scheduledConfig.formatStart(time);
		case 'ongoing':
			return todayConfig.formatStart(time);
		default:
			return overdueConfig.formatStart(time);
	}
};

export const formatEndTime = (value: DateTimeOffset, status: TaskStatus) => {
	const time = parseDateTimeOffset(value);

	if (!time) {
		return '';
	}

	switch (status) {
		case 'completed':
			return completedConfig.formatEnd(time);
		case 'scheduled':
			return scheduledConfig.formatEnd(time);
		case 'ongoing':
			return todayConfig.formatEnd(time);
		default:
			return overdueConfig.formatEnd(time);
	}
};
